const APP_DOWNLOAD_DOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.onelink\.me$/;

const isAppDownloadDomain = value =>
  typeof value === 'string' && APP_DOWNLOAD_DOMAIN_PATTERN.test(value.trim().toLowerCase());

module.exports = {
  isAppDownloadDomain
};
